import { render, staticRenderFns } from "./defterolustur.vue?vue&type=template&id=9fd1f89c&"
import script from "./defterolustur.vue?vue&type=script&lang=js&"
export * from "./defterolustur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports